export const deserializeCF = (cfEncodedContext: string): string[] => {
    const cfContext = JSON.parse(decodeURIComponent(cfEncodedContext));
    return cfContext.ctc && cfContext.ctc.v1
        ? (cfContext.ctc.v1 as string[])
        : [];
};
